import { render, staticRenderFns } from "./InternalCustomerAccountsDetail.vue?vue&type=template&id=a65879de&scoped=true"
import script from "./InternalCustomerAccountsDetail.vue?vue&type=script&lang=js"
export * from "./InternalCustomerAccountsDetail.vue?vue&type=script&lang=js"
import style0 from "./InternalCustomerAccountsDetail.vue?vue&type=style&index=0&id=a65879de&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65879de",
  null
  
)

export default component.exports